import { LocationSearchAddress } from './LocationSearchAddress';
import { LocationSearchAddressesList } from './LocationSearchAddressesList';
import { LocationSearchPredictionAddressesList } from './LocationSearchPredictionAddressesList';

export const Location = {
  SearchAddress: LocationSearchAddress,
  SearchAddressesList: LocationSearchAddressesList,
  SearchPredictionAddressesList: LocationSearchPredictionAddressesList,
};
